<template>
  <div class="archived-actions">
    <DxDropDownButton
      :items="items"
      :drop-down-options="{ width: 141, maxHeight: 179 }"
      :scrollable="true"
      class="selectActions"
      itemTemplate="actionsTemp"
      :text="$t('common.grid.selectActions')"
    >
      <template #actionsTemp="{ data }">
        <div
          class="dropdown-wrapper"
          id="new-dropdown"
          :class="{
            'top-bold-border': data.topBoldBorder,
          }"
          @click="
            $bvModal.show(data.modalId + userData.id);
            setActionData(userData);
          "
        >
          <div class="dropdown-items">
            <p :class="{ 'text-danger': data.variant == 'danger' }">
              {{ data.text }}
            </p>
          </div>
        </div>
      </template>
    </DxDropDownButton>

    <!-- Modals -->
    <b-modal
      :id="'activateModal_' + userData.id"
      hide-footer
      hide-header
      size="lg"
    >
      <ActivateUser
        :userId="userData.id"
        :userName="userData.fullName"
        :modalId="'activateModal_' + userData.id"
        @modalConfirmationUpdate="emitHandler('modalConfirmationUpdate')"
      />
    </b-modal>
    <b-modal
      :id="'deleteActionModal' + userData.id"
      hide-footer
      hide-header
      size="lg"
    >
      <Deleteaction
        @changeUserStatusOrDeleted="emitHandler('modalConfirmationUpdate')"
      />
      <!-- <DeleteUser
        :userId="userData.id"
        :userName="userData.fullName"
        :modalId="'deleteModal_' + userData.id"
        @modalConfirmationUpdate="emitHandler('modalConfirmationUpdate')"
      /> -->
    </b-modal>
  </div>
</template>

<script>
import DxDropDownButton from "devextreme-vue/drop-down-button";
import ActivateUser from "@/components/users/modals/ActivateUser.vue";
// import DeleteUser from "@/components/users/modals/DeleteUser.vue";
import Deleteaction from "@/components/users/DeleteAction.vue";
import { mapActions } from "vuex";

export default {
  components: { DxDropDownButton, ActivateUser, Deleteaction },
  data() {
    return {
      items: [
        {
          text: this.$t("users.form.activate"),
          modalId: "activateModal_",
          userId: this.userData.id,
        },
        {
          text: this.$t("common.delete"),
          modalId: "deleteActionModal",
          variant: "danger",
          topBoldBorder: true,
          userId: this.userData.id,
        },
      ],
    };
  },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {
    ...mapActions("modal", ["setData"]),
    setActionData(data) {
      Object.assign(data, { modalId: "deleteActionModal" + data.id });
      this.setData(data);
    },
    emitHandler(event) {
      this.$emit(event);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-bold-border {
  border-top: 5px solid #70707010;
}
.text-danger {
  color: #f46a6a;
}
</style>

<style lang="scss">
.archived-actions {
  .dx-overlay-content {
    inset-inline-start: -1px !important;
    top: 6px !important;
    width: 150px !important;
  }
}
</style>
